import { render } from "./reportDetail.vue?vue&type=template&id=494939f0&scoped=true"
import script from "./reportDetail.vue?vue&type=script&lang=js"
export * from "./reportDetail.vue?vue&type=script&lang=js"

import "./reportDetail.vue?vue&type=style&index=0&id=494939f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-494939f0"

export default script